import logoWhite from '../assets/images/navbar/envestnet_logo_white.svg';
import logoColor from '../assets/images/navbar/envestnet_logo.svg';
export var headerData = {
    menuItems: [
        {
            label: 'Our Ecosystem',
            url: '/our-ecosystem',
            id: 'our-ecosystem',
        },
        {
            label: 'Why Envestnet',
            url: '/why-envestnet',
            id: 'why-envestnet',
        },
        {
            label: 'Who we serve',
            url: '',
            id: 'who-we-serve',
            items: [
                {
                    label: 'RIAs',
                    url: 'https://envestnet.blog/',
                },
                {
                    label: 'Enterprises',
                    url: '/resources',
                },
                {
                    label: 'Asset Managers',
                    url: '/news',
                },
                {
                    label: 'Banks and Institutions',
                    url: '/press',
                },
                {
                    label: 'Broker-Dealer Representatives',
                    url: '/upcoming-events',
                },
            ],
        },
        {
            label: 'Resources',
            url: '',
            id: 'resources',
            items: [
                {
                    label: 'Blog',
                    url: 'https://envestnet.blog/',
                    isExternal: true,
                },
                {
                    label: 'Resource Library',
                    url: '/resources',
                },
                {
                    label: 'Newsroom',
                    url: '/news',
                },
                {
                    label: 'Press releases',
                    url: '/press',
                },
                {
                    label: 'Podcasts',
                    url: '/podcasts',
                },
                {
                    label: 'Events',
                    url: '/upcoming-events',
                },
                {
                    label: 'Envestnet Institute',
                    url: 'https://www.envestnetinstitute.com/',
                    isExternal: true,
                },
            ],
        },
        {
            label: 'Schedule a Demo',
            url: '/schedule-demo',
            id: 'schedule-demo',
        },
        {
            label: 'Log in',
            url: '',
            id: 'log-in',
            items: [
                {
                    label: 'Envestnet Portal',
                    url: 'https://advisor.envestnet.com/secure/login/envest.jsp?_ga=2.135506225.1087772580.1645730349-97951119.1639407311',
                    isExternal: true,
                },
                {
                    label: 'Envestnet | Tamarac',
                    url: 'https://www.tamaracinc.com/',
                    isExternal: true,
                },
                {
                    label: 'Envestnet | Yodlee',
                    url: '/',
                    isExternal: true,
                },
                {
                    label: 'Envestnet | MoneyGuide',
                    url: 'https://www.moneyguidepro.com/ifa/SignOn.aspx',
                    isExternal: true,
                },
                {
                    label: 'Envestnet | Retirement Solutions',
                    url: 'https://app.envestnetrs.com/#/login',
                    isExternal: true,
                },
            ],
        },
    ],
    siteLogo: [
        {
            view: 'mobile',
            url: logoColor,
        },
        {
            view: 'desktop',
            url: logoWhite,
        },
    ],
    navType: 'default',
};
